class Notes {
  constructor() {
    this.$notes = document.querySelector('[data-target="notes"]')?.children
    this.$notesContainer = document.querySelector('.notes-container')
  }

  append() {
    if (this.$notesContainer) {
      Array.from(this.$notes).forEach($note => {
        this.$notesContainer.appendChild($note)
      })
    }
  }

  displayApplicableModelChangeNotesInit(event) {
    var container = document.querySelector('.model-change-notes')

    container.classList.toggle('hidden', event !== 'attachment')
  }

  displayApplicableModelChangeNotes(event) {
    const container = document.querySelector('.model-change-notes')
    let text = ''

    if (event.target.nodeName === 'LABEL') {
      text = event.target.children[1].innerHTML
    } else {
      text = event.target.innerHTML
    }

    if (text !== '') {
      container.classList.toggle('hidden', text !== 'Attach Client Suitability')
    }
  }
}

export default Notes
